import { TriangleAlert } from "lucide-react";
import { agentMap, toneSurface, taskStatusMeta } from "@/lib/mockData";
import PriorityPill from "./PriorityPill";
import { cn } from "@/lib/utils";

const fmtDeadline = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export default function TaskCard({ task, onOpen }) {
  const isHuman = task.owner === "HUMAN";
  const ownerAgent = agentMap[task.owner];
  const tone = toneSurface[ownerAgent?.tone] ?? toneSurface.neutral;
  const isDarkAvatar = ownerAgent?.tone === "dark";
  const status = taskStatusMeta[task.status];

  return (
    <button
      type="button"
      data-testid={`task-card-${task.id}`}
      data-task-owner={isHuman ? "HUMAN" : "agent"}
      onClick={() => onOpen(task.id)}
      className={cn(
        "group relative flex flex-col gap-3 overflow-hidden rounded-2xl border border-black/[0.04] bg-white p-4 text-left shadow-[0_1px_0_rgba(0,0,0,0.02)] transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_24px_-12px_rgba(15,15,25,0.18)]",
        isHuman && "bg-[#FFF7EE]",
      )}
    >
      {isHuman && (
        <span className="absolute left-0 top-0 h-full w-[3px] bg-orange-500" aria-hidden />
      )}

      {/* Top */}
      <div className="flex items-start justify-between gap-2">
        <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.14em] text-zinc-500">
          <span
            className="inline-block h-1.5 w-1.5 rounded-full"
            style={{ backgroundColor: status.dot }}
          />
          {status.label}
        </span>
        <PriorityPill priority={task.priority} />
      </div>

      <div className="text-[13.5px] font-bold leading-snug text-zinc-900">
        {task.title}
      </div>

      <div className="mt-auto flex items-center justify-between gap-2">
        <div className="flex min-w-0 items-center gap-2">
          {isHuman ? (
            <span className="inline-flex items-center gap-1 rounded-full border border-orange-200 bg-orange-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-orange-700">
              <TriangleAlert className="h-3 w-3" strokeWidth={2.6} />
              Human
            </span>
          ) : (
            <>
              <span
                className={cn(
                  "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-extrabold",
                  isDarkAvatar
                    ? "bg-[#0B0B0E] text-white"
                    : cn(tone.bg, "text-zinc-900"),
                )}
                style={{ boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.04)" }}
              >
                {ownerAgent?.name?.[0]}
              </span>
              <span className="truncate text-[12px] font-semibold text-zinc-700">
                {ownerAgent?.name}
              </span>
            </>
          )}
        </div>
        <span className="text-[11px] font-semibold text-zinc-500">
          {fmtDeadline(task.deadline)}
        </span>
      </div>
    </button>
  );
}
